import {
  IonButton,
  IonContent,
  IonFooter,
  IonIcon,
  IonImg,
  IonModal,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
} from "@ionic/react";

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import RegistroCapacitacionAPI, { RolCapacitacion, ROL_SESSION_KEY as CAPACITACION_ROL_KEY } from "src/services/registroCapacitacion";
import EppAPI, { EPP_ROL_KEY, RolEpp, esOperadorEpp } from "src/services/epp";

import { useLocation, withRouter } from "react-router";

import { Typography } from "@material-ui/core";
import {
  busOutline,
  cashOutline,
  chevronDownOutline,
  chevronForwardOutline,
  homeOutline,
  informationCircleOutline,
  listOutline,
  swapVerticalOutline,
  pencil,
  megaphoneOutline,
  documentTextOutline, // Ícono para el nuevo módulo Acompañamiento
  swapHorizontalOutline,
  sparklesOutline,
  schoolOutline,
  cubeOutline,
  alertCircleOutline,
  personCircleOutline,
  peopleCircleOutline,
  calendarOutline,
  checkboxOutline,
  qrCodeOutline,
  cameraOutline,
  archiveOutline,
  settingsOutline,
  shieldCheckmarkOutline,
  libraryOutline,
  documentsOutline,
  locateOutline,
} from "ionicons/icons";

import { AppPage, MenuProps } from "src/utils/interfaces";
import EventosAPI from "src/services/eventos";
import { esAdminRecursos } from "src/services/recursos";
import CapacitacionAdmAPI, { CAPADM_ACCESO_KEY } from "src/services/capacitacionAdm";
import AgendaAPI, { AGENDA_ACCESO_KEY } from "src/services/agenda";
import "./Menu.css";
import { EVALUACION_SOLO_TIC } from "src/config/entorno"; // feature flag para visibilidad
import { useEffect, useState } from "react";
import LoginAPI from "src/services/login";
import Storage from "src/services/storage";
import PerfilPanel from "src/components/PerfilPanel";
import { obtenerEstadoBloqueoMarcacion } from "src/services/marcacionesBloqueos";
import { obtenerFeatureSwitches } from "src/services/featureSwitches";
import ClimaOrganizacionalAPI from "src/services/climaOrganizacional";
import { DEPARTAMENTOS_SOLICITUDES, departamentoVisible } from "src/config/departamentosSolicitudes";
import { cargarPermisoSst, permisoSstEnSesion } from "src/services/sst";
import { cargarPermisoRrhh, permisoRrhhEnSesion } from "src/services/solicitudesRRHH";
import { canViewModule, loadModulePermissions, ModulePermissionsMap } from "src/config/modulePermissions";
import { esGerenteDeOperaciones } from "src/config/gerenteOperaciones";
import { esCargoComoJefePedido } from "src/config/cargoPedido";
import { puedeVerSugerenciaPs } from "src/config/sugerenciaPs";
import { sincronizarPermisosModulos } from "src/services/modulePermissions";
import { listarRelevamientosVisitas } from "src/services/relevamientoVisitas";
import { obtenerAccesoVisitaUE } from "src/services/visitasUnidadesEspecializadas";
import {
  obtenerMiRol,
  obtenerMisTemas,
  MiRolResponse,
  MiTemaItem,
} from "src/services/entregasMasivas";

const CEDULA_AUTORIZADA_REPORTE_EVAL = "5355286";

const parseJwtUsuario = (token?: string): string | null => {
  try {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const json = JSON.parse(atob(padded));
    const usuario = json?.usuario ?? json?.user ?? json?.sub;
    if (usuario === undefined || usuario === null) return null;
    return String(usuario).trim();
  } catch {
    return null;
  }
};

const Menu: React.FC<MenuProps> = ({
  user,
  cargo,
  cerrarSesion,
  contentId,
  history,
}) => {
  const location = useLocation();

  type MenuAccordionKey = "operativa" | "evaluaciones";
  const [openGroup, setOpenGroup] = useState<MenuAccordionKey | null>(null);
  const [perfilOpen, setPerfilOpen] = useState(false);

  const esSeleccionada = (page: AppPage) => {
    return page.url && page.url.includes(location.pathname) ? "selected" : "";
  };

  const paginaPermitida = (pagina: AppPage) => {
    // Si una página declara `cargos`, solo esos cargos la ven.
    // Si no declara nada, la página es visible por defecto.
    if (!pagina.cargos || pagina.cargos.length === 0) return true;

    const cargoActual = (cargo ?? "").trim();
    if (!cargoActual) return false;

    const cargoActualNorm = cargoActual.toLowerCase();
    return pagina.cargos.some((c) => String(c ?? "").trim().toLowerCase() === cargoActualNorm);
  };


  const [version, setVersion] = useState('');
  const [puedeVerReporteEval, setPuedeVerReporteEval] = useState(false);
  const [puedeVerMarcaciones, setPuedeVerMarcaciones] = useState(true);
  const [tipoFuncionario, setTipoFuncionario] = useState<string | null>(null);
  const [climaHabilitado, setClimaHabilitado] = useState(false);
  const [modulePermissions, setModulePermissions] = useState<ModulePermissionsMap>(() => loadModulePermissions());
  const [climaYaRealizada, setClimaYaRealizada] = useState(
    () => sessionStorage.getItem('clima_organizacional_realizada_session') === '1'
  );
  const [esUsuarioServiciosEspecializados, setEsUsuarioServiciosEspecializados] = useState(false);
  const [puedeVerRelevamientoVisitas, setPuedeVerRelevamientoVisitas] = useState(false);
  const [puedeVerVisitasUE, setPuedeVerVisitasUE] = useState(false);
  const [esAdminEventos, setEsAdminEventos] = useState(false);
  const [tieneAsistenciaEventos, setTieneAsistenciaEventos] = useState(false);
  // Capacitaciones Administrativas: anfitrion = padron administrativo (cacheado por sesion en el servicio).
  const [esAnfitrionCapAdm, setEsAnfitrionCapAdm] = useState(
    () => sessionStorage.getItem(CAPADM_ACCESO_KEY) === "1"
  );
  // Agendamientos: gestion por tabla de admins / gestores / responsables (cacheado por sesion).
  const [gestionaAgenda, setGestionaAgenda] = useState(() => {
    try {
      return Boolean(JSON.parse(sessionStorage.getItem(AGENDA_ACCESO_KEY) || "{}").gestiona);
    } catch {
      return false;
    }
  });
  /* Cacheado en sessionStorage: el Menu se remonta en CADA cambio de ruta y la
     condición de admin no cambia dentro de una sesión. Sin esto agregaríamos
     una request por navegación para todos los usuarios. */
  const [esAdminRec, setEsAdminRec] = useState(
    () => sessionStorage.getItem("recursos_es_admin_session") === "1"
  );
  // Capacitaciones (Técnica / Seguridad): tipos que registra y administra
  // (AE_C_Admin). Cacheado en la sesión por el servicio, como Recursos.
  const [rolCap, setRolCap] = useState<RolCapacitacion | null>(() => {
    try {
      const cache = sessionStorage.getItem(CAPACITACION_ROL_KEY);
      return cache ? JSON.parse(cache) : null;
    } catch {
      return null;
    }
  });
  // Control de EPP: admin SSHO / responsable de depósito / colaborador con entregas.
  const [rolEpp, setRolEpp] = useState<RolEpp | null>(() => {
    try {
      const cache = sessionStorage.getItem(EPP_ROL_KEY);
      return cache ? JSON.parse(cache) : null;
    } catch {
      return null;
    }
  });
  // Solicitudes a SST: EMSYS decide (fiscales, jefes y administrativos). Cacheado por sesion.
  const [puedeSst, setPuedeSst] = useState<boolean>(() => permisoSstEnSesion() === true);
  const [emRol, setEmRol] = useState<MiRolResponse | null>(null);
  const [emTemas, setEmTemas] = useState<MiTemaItem[]>([]);

  useEffect(() => {
    const fetchVersion = async () => {
      // Check if running on a native platform (iOS or Android)
      if (Capacitor.isNativePlatform()) {
        try {
          const { version } = await App.getInfo();
          setVersion(version);
        } catch (error) {
          console.error('Failed to get app info:', error);
        }
      } else {
        console.warn('App.getInfo() is not implemented on the web');
        setVersion('Web version'); // Fallback or alternative value for web
      }
    };

    fetchVersion();
  }, []);

  useEffect(() => {
    const cargarUsuarioServiciosEspecializados = async () => {
      try {
        const response = await LoginAPI.me();
        const cedula = String(response?.data?.datos?.emp_cedula || '').trim();
        setEsUsuarioServiciosEspecializados(cedula === '4218167');
      } catch {
        setEsUsuarioServiciosEspecializados(false);
      }
    };
    cargarUsuarioServiciosEspecializados();
  }, []);

  // Acceso al módulo de Eventos: admin (tabla AE_Evento_Admin) y/o tomador de asistencia.
  useEffect(() => {
    const cargarAccesoEventos = async () => {
      try {
        setEsAdminEventos(await EventosAPI.esAdmin());
      } catch {
        setEsAdminEventos(false);
      }
      try {
        const evs = await EventosAPI.misEventosAsistencia();
        setTieneAsistenciaEventos((evs || []).length > 0);
      } catch {
        setTieneAsistenciaEventos(false);
      }
    };
    cargarAccesoEventos();
  }, []);

  useEffect(() => {
    if (permisoSstEnSesion() !== null) return;
    cargarPermisoSst().then((puede) => {
      if (puede !== null) setPuedeSst(puede);
    });
  }, []);

  // Solicitudes a RRHH: EMSYS decide (fiscales, jefes y administrativos). Los
  // operarios no lo piden: nunca pueden y son la mayoria de las sesiones.
  // Solo para re-renderizar: departamentoVisible lee el valor de la sesion.
  const [, setPuedeRrhh] = useState<boolean | null>(() => permisoRrhhEnSesion());
  useEffect(() => {
    const c = (cargo || "").toLowerCase();
    if (!c || c.includes("operari") || permisoRrhhEnSesion() !== null) return;
    cargarPermisoRrhh().then((puede) => {
      if (puede !== null) setPuedeRrhh(puede);
    });
  }, [cargo]);

  useEffect(() => {
    CapacitacionAdmAPI.esAnfitrion().then(setEsAnfitrionCapAdm);
  }, []);

  useEffect(() => {
    RegistroCapacitacionAPI.miRol().then(setRolCap);
  }, []);

  useEffect(() => {
    EppAPI.miRol().then(setRolEpp);
  }, []);

  useEffect(() => {
    AgendaAPI.acceso().then((a) => setGestionaAgenda(a.gestiona));
  }, []);

  // Administración de Recursos: se habilita por tabla (AE_Recurso_Admin), no por
  // cargo, igual que Eventos. El servicio ya devuelve false ante cualquier error.
  useEffect(() => {
    const cargarAccesoRecursos = async () => {
      if (sessionStorage.getItem("recursos_es_admin_session") !== null) return;
      try {
        const puede = await esAdminRecursos();
        sessionStorage.setItem("recursos_es_admin_session", puede ? "1" : "0");
        setEsAdminRec(puede);
      } catch {
        /* Sin marcar la sesión: se reintenta en la próxima navegación. */
      }
    };
    cargarAccesoRecursos();
  }, []);

  useEffect(() => {
    const cargarRolEntregasMasivas = async () => {
      try {
        const [rol, temas] = await Promise.all([
          obtenerMiRol(),
          obtenerMisTemas().catch(() => []),
        ]);
        setEmRol(rol);
        setEmTemas(temas || []);
      } catch {
        setEmRol(null);
        setEmTemas([]);
      }
    };
    cargarRolEntregasMasivas();
  }, []);

  useEffect(() => {
    const cargarAccesoRelevamiento = async () => {
      try {
        await listarRelevamientosVisitas();
        setPuedeVerRelevamientoVisitas(true);
      } catch {
        setPuedeVerRelevamientoVisitas(false);
      }
    };
    cargarAccesoRelevamiento();
  }, []);

  useEffect(() => {
    const cargarAccesoVisitasUE = async () => {
      try {
        const acc = await obtenerAccesoVisitaUE();
        setPuedeVerVisitasUE(Boolean(acc?.tiene_acceso));
      } catch {
        setPuedeVerVisitasUE(false);
      }
    };
    cargarAccesoVisitasUE();
  }, []);

  useEffect(() => {
    const cargarPermisoReporte = async () => {
      try {
        const sesion = await Storage.getSesion();
        const cedula = parseJwtUsuario(sesion?.token);
        setPuedeVerReporteEval(cedula === CEDULA_AUTORIZADA_REPORTE_EVAL);
      } catch {
        setPuedeVerReporteEval(false);
      }
    };

    cargarPermisoReporte();
  }, []);

  useEffect(() => {
    const cargarPermisoMarcaciones = async () => {
      try {
        const estado = await obtenerEstadoBloqueoMarcacion();
        setPuedeVerMarcaciones(!estado.bloqueado);
      } catch {
        setPuedeVerMarcaciones(true);
      }
    };

    cargarPermisoMarcaciones();
  }, []);

  useEffect(() => {
    const cargarTipoFuncionario = async () => {
      try {
        const { data } = await LoginAPI.me();
        const tf = data?.datos?.emp_tipo_funcionario;
        setTipoFuncionario(tf !== undefined && tf !== null ? String(tf) : '');
      } catch {
        setTipoFuncionario(null);
      }
    };

    cargarTipoFuncionario();
  }, []);

  useEffect(() => {
    const cargarFeatureSwitches = async () => {
      try {
        const switches = await obtenerFeatureSwitches();
        setClimaHabilitado(Boolean(switches?.climaOrganizacional));
      } catch {
        setClimaHabilitado(false);
      }
    };

    cargarFeatureSwitches();
  }, []);

  useEffect(() => {
    let activo = true;

    const syncPermissionsLocal = () => {
      setModulePermissions(loadModulePermissions());
    };

    const syncPermissionsRemoto = async () => {
      const permisos = await sincronizarPermisosModulos();
      if (!activo) return;
      setModulePermissions(permisos);
    };

    syncPermissionsRemoto();

    const onFocus = () => {
      syncPermissionsRemoto();
    };

    window.addEventListener("storage", syncPermissionsLocal);
    window.addEventListener("focus", onFocus);

    return () => {
      activo = false;
      window.removeEventListener("storage", syncPermissionsLocal);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  useEffect(() => {
    const cargarEstadoClima = async () => {
      if (!climaHabilitado) {
        setClimaYaRealizada(false);
        return;
      }

      try {
        const response = await ClimaOrganizacionalAPI.obtenerEstado();
        const ya = Boolean(response?.data?.ya_realizada);
        setClimaYaRealizada(ya);
        try {
          if (ya) {
            sessionStorage.setItem('clima_organizacional_realizada_session', '1');
          } else {
            sessionStorage.removeItem('clima_organizacional_realizada_session');
          }
        } catch {}
      } catch {
        setClimaYaRealizada(sessionStorage.getItem('clima_organizacional_realizada_session') === '1');
      }
    };

    cargarEstadoClima();
  }, [climaHabilitado, location.pathname]);

  useEffect(() => {
    if (sessionStorage.getItem('clima_organizacional_realizada_session') === '1') {
      setClimaYaRealizada(true);
    }
  }, [location.pathname]);

  const pages: AppPage[] = [
    {
      title: "Inicio",
      url: "/home",
      icon: homeOutline,
    },

    ...(puedeVerMarcaciones
      ? [{
        title: "Marcación",
        url: "/marcar",
        icon: swapVerticalOutline,
      }]
      : []),
    {
      title: "Historial de trabajo",
      url: "/historial-de-trabajo",
      src: "assets/icon/history.svg",
    },
    {
      title: "Reclamos de horas",
      url: "/reclamos",
      src: "assets/icon/claim.svg",
    },
    {
      title: "Recibos Salariales",
      url: "/salarios",
      icon: cashOutline,
    },
    {
      title: "Reembolso de Pasajes",
      url: "/reembolsos-pasajes",
      icon: busOutline,
      // Solo cargos alcanzados por el reembolso; el backend re-valida contra
      // el parametro CARGOS_ALCANZADOS de EMSYS.
      cargos: [
        "OPERARIO CUBRE VACACIONES",
        "OPERARIO CUBRE AUSENCIA",
        "OPERARIO CONTACT CENTER",
      ],
    },
    {
      // Biblioteca de capacitaciones y material. Visible para todos: el backend
      // filtra el contenido segun la audiencia que el admin definio por recurso.
      title: "Recursos",
      url: "/recursos",
      icon: libraryOutline,
    },
    {
      title: "Sobre Nosotros",
      url: "/nosotros",
      icon: informationCircleOutline,
    },
    {
      title: "Documentaciones",
      url: "/documentaciones",
      icon: documentsOutline,
    },
    // {
    //   title: "Denuncias",
    //   url: "/denuncias",
    //   icon: megaphoneOutline,
    // },
    {
      title: "Denuncias",
      url: "/denuncias",
      icon: megaphoneOutline,
    },
    {
      title: "Atencion Interna",
      url: "/atencion-cliente",
      icon: calendarOutline,
    },
  ];

  // const paginasPermitidas = pages.filter(paginaPermitida);

  const menuItem = [{
    title: "Gestiones",
    url: "/gestiones",
    icon: pencil,
  },
  {
    title: "Gestión de Errores",
    url: "/gestion-errores",
    icon: alertCircleOutline,
  },
  {
    title: "Fiscalizacion",
    url: "/fiscalizacion",
    src: "assets/icon/fiscalizacion.svg",
    },
  {
    title: "Asignacion de Recursos",
    url: "/asignacion-recursos",
    icon: cubeOutline,
  },
  {
    title: "Pedido de Productos",
    url: "/pedido-de-productos",
    src: "assets/icon/pedidoProducto-COD1.svg",
    },]

  const menuItemFiscalizacionOnly = [{
    title: "Fiscalizacion",
    url: "/fiscalizacion",
    src: "assets/icon/fiscalizacion.svg",
  }]

  const menuItemJEFE = [
  {
    title: "Pedido de Productos",
    url: "/pedido-de-productos",
    src: "assets/icon/pedidoProducto-COD1.svg",
    }]

  // Ítem del nuevo módulo Evaluación de Desempeño
  const menuItemEvaluacion = [{ // definir elemento del menú como arreglo para reutilizar la misma lógica de inserción
    title: "Evaluación de Desempeño", // texto a mostrar en el menú lateral
    url: "/evaluacion-de-desempeno", // ruta definida en el router principal
    icon: documentTextOutline, // ícono de documento como propuesta inicial
  }];

  // Ítem del reporte jerárquico (solo cédula autorizada)
  const menuItemReporteEvaluacion = [{
    title: "Reporte Eval. Desempeño",
    url: "/evaluacion-de-desempeno/reporte",
    icon: documentTextOutline,
  }];

  const menuItemEvaluacionCapacitacion = [{
    title: "Evaluacion Capacitaciones Tecnicas",
    url: "/evaluacion-capacitacion",
    icon: schoolOutline,
  }];
  const menuItemClima = [{
    title: 'Clima Organizacional',
    url: '/clima-organizacional',
    icon: peopleCircleOutline,
  }];
  const menuItemEvaluacionVisitas = [{
    title: "Visitas Operaciones",
    url: "/evaluacion-visitas",
    icon: documentTextOutline,
  }];
  const menuItemRelevamientoVisitas = [{
    title: "Visitas Comercial",
    url: "/relevamiento-visitas",
    icon: documentTextOutline,
  }];
  const menuItemReconocimiento = [{
    title: "Visitas de Reconocimiento a nuevos PS",
    url: "/evaluacion-reconocimiento",
    icon: documentTextOutline,
  }];
  const menuItemVisitasUE = [{
    title: "Visitas Unidades Especializadas",
    url: "/visitas-unidades-especializadas",
    icon: documentTextOutline,
  }];

  const menuItemRelevamientoOperativo = [{
    title: "Repro",
    url: "/relevamiento-operativo",
    icon: documentTextOutline,
  }];

  const menuItemOrdenTrabajo = [{
    title: "Orden de Trabajo",
    url: "/orden-trabajo",
    icon: documentTextOutline,
  }];

  const menuItemAsignacionesCapacitador = [{
    title: "Asignaciones",
    url: "/asignaciones-capacitador",
    icon: documentTextOutline,
  }];

  // Solo para el capacitador técnico (pestaña "Asignadas"): los solicitantes
  // entran por Solicitudes > Gestión de Talento.
  const menuItemSolicitudesCapacitacion = [{
    title: "Capacitaciones Asignadas",
    url: "/solicitudes-capacitacion",
    icon: schoolOutline,
  }];

  const menuItemRegistroCapacitacion = [{
    title: "Registro de Capacitación",
    url: "/registro-capacitacion",
    icon: schoolOutline,
  }];

  const menuItemHistorialCapacitacion = [{
    title: "Historial de Capacitaciones",
    url: "/historial-capacitacion",
    icon: listOutline,
  }];

  // Definimos el ítem del nuevo módulo Acompañamiento
  const menuItemAcompanamiento = [{ // Arreglo para reusar la misma lógica de inserción
    title: "Acompañamiento", // Título correcto del módulo en el menú
    url: "/acompanamiento", // Ruta a la nueva página
    icon: documentTextOutline, // Ícono de documento para identificar el módulo
  }];
  // Nuevo bloque solo para fiscales
  const menuItemPlanificacion = [{
    title: "Planificación de Visitas",
    url: "/planificacion-visitas",
    src: "assets/icon/planificacion.svg", 
  }];


  // Ítem del nuevo módulo Reemplazos (nuevo) visible para Fiscales/Jefes/Líderes/TIC/Dev/Gerencia TI
  const menuItemReemplazosV2 = [{
    title: "Reemplazos (nuevo)",
    url: "/reemplazos-v2",
    icon: swapHorizontalOutline,
  }];

  // Ítem del módulo de gestión "Notificación de Reemplazos" (estado de confirmaciones)
  const menuItemNotificacionReemplazos = [{
    title: "Notificación de Reemplazos",
    url: "/notificacion-reemplazos",
    icon: listOutline,
  }];

  // Ítem del "Reporte de Remplazos Contact" (Coordinador Administrativo de Operaciones)
  const menuItemReporteReemplazosContact = [{
    title: "Reporte de Remplazos Contact",
    url: "/reporte-reemplazos-contact",
    icon: listOutline,
  }];

  // Ítem del módulo Mis Casos (bandeja de ausencias del fiscalizador)
  const menuItemMisCasos = [{
    title: "Mis Casos",
    url: "/mis-casos",
    icon: alertCircleOutline,
  }];

  // Ítem del nuevo módulo Asignaciones (nuevo) estilo EMSYS - visible para Fiscales
  const menuItemAsignacionesV2 = [{
    title: "Asignaciones (nuevo)",
    url: "/asignaciones-v2",
    icon: documentTextOutline,
  }];

  // Sugerencia por Geolocalizacion (reporte de EMSYS): gerente, jefes, analista y fiscales.
  const menuItemSugerenciaPs = [{
    title: "Sugerencia por Geolocalización",
    url: "/sugerencia-ps",
    icon: locateOutline,
  }];

  const menuItemLimpiezasProfundas = [{
    title: "Limpiezas Profundas",
    url: "/limpiezas-profundas",
    icon: sparklesOutline,
  }];

  const menuItemServiciosEspecializados = [{
    title: "Servicios Especializados",
    url: "/servicios-especializados",
    icon: documentTextOutline,
  }];

  // Ítem del módulo Entrega de Folleto (Reporte de Sostenibilidad) - Ejecutivos Comerciales
  const menuItemEntregaFolleto = [{
    title: "Reporte de Sostenibilidad",
    url: "/entrega-folleto",
    icon: documentTextOutline,
  }];

  // Solicitudes: puerta de entrada por departamento. Hoy el unico
  // departamento es RRHH (reemplaza la carga que se hacia en Flokzu); la lista
  // vive en config/departamentosSolicitudes.ts. EMSYS revalida el permiso.
  const menuItemSolicitudes = [{
    title: "Solicitudes",
    url: "/solicitudes",
    icon: documentTextOutline,
  }];

  const menuItemRutinas = [{
    title: "Rutinas",
    url: "/rutinas",
    icon: listOutline,
  }];

  const menuItemMiRutina = [{
    title: "Mi Rutina",
    url: "/mi-rutina",
    icon: listOutline,
  }];

  const menuItemMisAsignaciones = [{
    title: "Mis Asignaciones",
    url: "/mis-asignaciones",
    icon: listOutline,
  }];

  const menuItemEventosAdmin = [{
    title: "Eventos",
    url: "/eventos/admin",
    icon: calendarOutline,
  }];

  const menuItemEventosAsistencia = [{
    title: "Tomar asistencia",
    url: "/eventos/asistencia",
    icon: checkboxOutline,
  }];

  // Para los titulos usamos el nombre de un tema de ENTREGA (no de consumo).
  const temaEntregaNombre = emTemas.find(
    (t) => t.modo_salida !== "consumo"
  )?.nombre;

  const menuItemEmMiQR = [{
    title: temaEntregaNombre ? `Mi QR - ${temaEntregaNombre}` : "Mi QR",
    url: "/entregas-masivas/mi-qr",
    icon: qrCodeOutline,
  }];

  const menuItemEmRegistrar = [{
    title: temaEntregaNombre
      ? `Registrar entrega - ${temaEntregaNombre}`
      : "Registrar entrega",
    url: "/entregas-masivas/registrar",
    icon: cameraOutline,
  }];

  const menuItemEmMiStock = [{
    title: "Mi stock - Entregas",
    url: "/entregas-masivas/mi-stock",
    icon: archiveOutline,
  }];

  const menuItemEmAdmin = [{
    title: "Admin Entregas Masivas",
    url: "/entregas-masivas/admin",
    icon: settingsOutline,
  }];

  const menuItemCapAdmAnfitrion = [{
    title: "Capacitaciones administrativas",
    url: "/capacitaciones-adm",
    icon: schoolOutline,
  }];

  const menuItemCapAdmMis = [{
    title: "Mis capacitaciones adm",
    url: "/capacitaciones-adm/mis",
    icon: qrCodeOutline,
  }];

  const menuItemAgenda = [{
    title: "Agendamientos",
    url: "/agenda",
    icon: calendarOutline,
  }];

  const menuItemAgendaGestion = [{
    title: "Gestión de agendas",
    url: "/agenda/gestion",
    icon: settingsOutline,
  }];

  const menuItemMantenimientoCapTecnica = [{
    title: "Mantenimiento Cap. Técnicas",
    url: "/capacitaciones/mantenimiento/tecnica",
    icon: settingsOutline,
  }];

  const menuItemMantenimientoCapSeguridad = [{
    title: "Mantenimiento Cap. Seguridad",
    url: "/capacitaciones/mantenimiento/seguridad",
    icon: settingsOutline,
  }];

  const menuItemEpp = [{
    title: "Control de EPP",
    url: "/epp",
    icon: shieldCheckmarkOutline,
  }];

  const menuItemMisEpp = [{
    title: "Mis EPP",
    url: "/epp/mis-epp",
    icon: shieldCheckmarkOutline,
  }];

  const menuItemRecursosAdmin = [{
    title: "Admin Recursos",
    url: "/recursos/admin",
    icon: settingsOutline,
  }];

  // Mostrar solo para JEFE DE OPERACIONES (incluye variante JEFE DE OPE) y TIC
  const cargoTxt = cargo || '';
  // La gerente de Operaciones ve todo lo de jefe y de fiscal (en fiscal elige con qué fiscal trabaja).
  const esGerenteOperaciones = esGerenteDeOperaciones(cargoTxt);
  const esJefeOperaciones = cargoTxt.includes('JEFE DE OPERACIONES') || cargoTxt.includes('JEFE DE OPE') || esGerenteOperaciones; // Habilita a Jefes de Operaciones
  const esTic = cargoTxt.includes('TIC'); // Habilita a TIC
  const esDevFront = cargoTxt.includes('DESARROLLADOR FRONT END'); // Nuevo: habilita a Desarrollador Front End
  const esGerenteTI = cargoTxt.includes('GERENTE DE TECNOLOGIAS DE LA INFORMACION'); // Nuevo: habilita al Gerente de TI
  const esCapacitadorTecnico = cargoTxt.includes('CAPACITADOR TECNICO'); // Solo lectura de asignaciones
  const esCoordinadorCap = cargoTxt.toUpperCase().includes('COORDINADOR DE CAPACITACIONES TECNICAS');
  const puedeRegistrarCapacitacion = esCapacitadorTecnico || esCoordinadorCap;
  const addItemsUnique = (items: AppPage[], insertAt: number) => {
    let offset = 0;
    for (const item of items) {
      if (!item.url || pages.some(p => p.url === item.url)) continue;
      pages.splice(insertAt + offset, 0, item);
      offset += 1;
    }
  };
  const baseInsertAt = 4;

  // NUEVO: habilitar "Pedido de Productos" para Jefatura y Gerencia de Operaciones
  // - Detectamos Gerencia de Operaciones explícitamente para cubrir ese rol
  // - Insertamos el ítem específico de Jefatura en la misma posición estable que otros módulos operativos

  // NUEVO: Normalizamos el cargo a minúsculas para comparar roles sin errores por mayúsculas/minúsculas
  const cargoNorm = (cargo || '').toLowerCase(); // Ej.: "FISCALIZADOR A" -> "fiscalizador a"
  // NUEVO: Detectamos si el usuario es fiscal por inclusión de la palabra "fiscal" en el cargo
  const esFiscal = cargoNorm.includes('fiscal') || esGerenteOperaciones; // Cubre variantes como "fiscal", "fiscalizador", etc.
  const esOperario = cargoNorm.includes('operario') || cargoNorm.includes('operaria');
  const esGerenteGeneralAdjunto = cargoNorm.includes('gerente general adjunto');
  // NUEVO: Detectamos roles adicionales solicitados para Evaluación de Desempeño
  const esSupervisor = cargoNorm.includes('supervisor'); // habilita a Supervisores
  const esLider = cargoNorm.includes('lider') || cargoTxt.includes('LIDER AGENTIS'); // habilita a Líderes y a LIDER AGENTIS
  const esGerenteOperEsp = cargoTxt === 'GERENTE DE OPERACIONES' || cargoTxt === 'GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS'; // variantes de Gerencia de Operaciones
  const esGerenteTI2 = cargoTxt.includes('GERENTE DE TECNOLOGIAS DE LA INFORMACION'); // Gerente de TI
  const esDesarrollador = cargoNorm.includes('desarrollador'); // habilita menu solo para desarrolladores
  const puedeVerEvaluacionVisitas = esDesarrollador || esJefeOperaciones || esGerenteOperEsp || esGerenteGeneralAdjunto;
  const puedeVerLimpiezas = esFiscal || esJefeOperaciones || cargoNorm.includes('gerente de operaciones') || cargoNorm.includes('gerente de operaciones - unidades especializadas');
  const puedeVerEvaluacion = EVALUACION_SOLO_TIC
    ? esTic
    : (esFiscal || esJefeOperaciones || esSupervisor || esLider || esGerenteOperEsp || esTic || esGerenteTI2);
  const puedeEvaluarCapacitaciones = esFiscal; // consolidación de permisos
  const ahora = new Date(); // obtener fecha actual del cliente para controlar visibilidad por mes
  const mesActual = ahora.getMonth(); // 0=enero, 1=febrero, 11=diciembre
  const esDiciembreEneroFebrero = mesActual === 11 || mesActual === 0 || mesActual === 1; // visible en diciembre, enero y febrero
  const puedeVerClima = climaHabilitado && tipoFuncionario !== null && !climaYaRealizada;
  const moduloActivo = (id: string) => canViewModule(id, cargo, modulePermissions);
  console.log("CARGO DETECTADO:", cargo);
  if ((esJefeOperaciones || esTic || esDevFront || esGerenteTI) && moduloActivo("acompanamiento")) {
    addItemsUnique(menuItemAcompanamiento, baseInsertAt);
  }
  if ((esJefeOperaciones || esTic || esDevFront || esGerenteTI) && moduloActivo("reemplazos")) {
    addItemsUnique(menuItemReemplazosV2, baseInsertAt + 1);
  }
  if (esFiscal && (moduloActivo("gestiones") || moduloActivo("fiscalizacion") || moduloActivo("asignacion_recursos") || moduloActivo("pedido_productos"))) {
    const menuFiscalFiltrado = menuItem.filter((item) => {
      if (item.url === "/gestiones") return moduloActivo("gestiones");
      if (item.url === "/fiscalizacion") return moduloActivo("fiscalizacion");
      if (item.url === "/asignacion-recursos") return moduloActivo("asignacion_recursos");
      if (item.url === "/pedido-de-productos") return moduloActivo("pedido_productos");
      return true;
    });
    addItemsUnique(menuFiscalFiltrado, baseInsertAt);
  }
  if (esFiscal && moduloActivo("planificacion_visitas")) {
    addItemsUnique(menuItemPlanificacion, baseInsertAt + 1);
  }
  if (esFiscal && moduloActivo("reemplazos")) {
    addItemsUnique(menuItemReemplazosV2, baseInsertAt + 2);
  }
  // Gestión de Errores (unificada con la ex "Gestión Marcación (nuevo)"): siempre visible
  // para fiscales y la Gerente de Operaciones, aunque no tengan activos los módulos de arriba.
  // Si ya se agregó con el bloque de fiscal, addItemsUnique no lo duplica.
  if (esFiscal) {
    addItemsUnique(menuItem.filter((item) => item.url === "/gestion-errores"), baseInsertAt + 3);
  }
  // "Notificación de Reemplazos": fiscal (ve sus PS) y rango mayor (ve todo). El backend
  // aplica la visibilidad real; aca solo decidimos a quien le mostramos el item de menu.
  const puedeVerNotifReemplazos = esFiscal || esJefeOperaciones || esGerenteOperEsp
    || esSupervisor || esLider || esTic || esGerenteTI2 || esDesarrollador
    || cargoNorm.includes('gerente de operaciones');
  if (puedeVerNotifReemplazos && moduloActivo("notificacion_reemplazos")) {
    addItemsUnique(menuItemNotificacionReemplazos, baseInsertAt + 4);
  }
  // "Reporte de Remplazos Contact": Coordinador Administrativo de Operaciones
  // (desarrollador para soporte). El backend valida el cargo nuevamente.
  const esCoordinadorAdminOper = cargoTxt.toUpperCase().includes('COORDINADOR ADMINISTRATIVO DE OPERACIONES');
  if (esCoordinadorAdminOper || esDesarrollador || esGerenteOperaciones) {
    addItemsUnique(menuItemReporteReemplazosContact, baseInsertAt + 5);
  }
  if (esFiscal && moduloActivo("mis_casos")) {
    addItemsUnique(menuItemMisCasos, baseInsertAt + 5);
  }
  if (esFiscal && moduloActivo("asignaciones_v2")) {
    addItemsUnique(menuItemAsignacionesV2, baseInsertAt + 6);
  }
  if (puedeVerSugerenciaPs(cargoTxt) && moduloActivo("sugerencia_ps")) {
    addItemsUnique(menuItemSugerenciaPs, baseInsertAt + 7);
  }
  // Entrega de Folleto (Reporte de Sostenibilidad): solo Ejecutivos Comerciales.
  const esEjecutivoComercial = cargoNorm.includes('ejecutivo comercial');
  if (esEjecutivoComercial) {
    addItemsUnique(menuItemEntregaFolleto, pages.length);
  }
  // Solicitudes (hub por departamento): RRHH para Fiscales y Jefes de
  // Operaciones; Gestion de Talento (capacitaciones) para Fiscales y Supervisores.
  // El permiso real lo aplica EMSYS; aca solo se decide si el item se ve. El
  // menu muestra "Solicitudes" si hay al menos un departamento habilitado, asi
  // que agregar un departamento no obliga a tocar esta condicion.
  const hayDepartamentoDeSolicitudes = DEPARTAMENTOS_SOLICITUDES.some((d) =>
    departamentoVisible(d, cargo, modulePermissions),
  );
  // GafCORE: cualquier cargo menos operario (EMSYS revalida al crear).
  if ((esFiscal || esJefeOperaciones || esSupervisor || esDesarrollador || puedeSst || !esOperario) &&
      moduloActivo("solicitudes") &&
      hayDepartamentoDeSolicitudes) {
    addItemsUnique(menuItemSolicitudes, pages.length);
  }
  if (esGerenteGeneralAdjunto && moduloActivo("fiscalizacion")) {
    addItemsUnique(menuItemFiscalizacionOnly, baseInsertAt);
  }
  // El Analista Sr. de Operaciones aprueba los pedidos de sus fiscales como jefatura.
  if ((esJefeOperaciones || esCargoComoJefePedido(cargoTxt)) && moduloActivo("pedido_productos")) {
    addItemsUnique(menuItemJEFE, baseInsertAt);
  }
  if (esJefeOperaciones && moduloActivo("planificacion_visitas")) {
    addItemsUnique(menuItemPlanificacion, baseInsertAt + 1);
  }
  if ((esGerenteOperEsp || cargoTxt.includes('LIDER AGENTIS')) && moduloActivo("pedido_productos")) {
    addItemsUnique(menuItemJEFE, baseInsertAt);
  }
  if (esGerenteOperEsp && moduloActivo("planificacion_visitas")) {
    addItemsUnique(menuItemPlanificacion, baseInsertAt + 1);
  }
  // // NUEVO: Normalizamos el cargo a minúsculas para comparar roles sin errores por mayúsculas/minúsculas
  // const cargoNorm = (cargo || '').toLowerCase(); // Ej.: "FISCALIZADOR A" -> "fiscalizador a"
  // // NUEVO: Detectamos si el usuario es fiscal por inclusión de la palabra "fiscal" en el cargo
  // const esFiscal = cargoNorm.includes('fiscal'); // Cubre variantes como "fiscal", "fiscalizador", etc.
  // // NUEVO: Si es fiscal, insertamos los módulos operativos que estaban declarados pero no visibles
  // if (esFiscal) {
  //   // Insertamos el bloque de Gestiones/Fiscalización/Pedido de Productos en una posición estable (después de Salarios)
  //   // Nota: usamos splice para evitar duplicados por render, ya que pages se re-crea en cada render
  //   pages.splice(4, 0, ...menuItem); // Agrega los tres ítems para perfiles fiscales
  // }

  // Inserción del ítem Evaluación de Desempeño después de "Recibos Salariales" si el cargo está autorizado
  if (puedeVerEvaluacion && esDiciembreEneroFebrero && moduloActivo("evaluacion_desempeno")) { // validar permisos y mostrar solo en diciembre/enero/febrero
    const idxRecibos = pages.findIndex(p => p.url === "/salarios"); // buscar la posición de Recibos Salariales
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length; // calcular posición de inserción
    pages.splice(insertAt, 0, ...menuItemEvaluacion); // insertar el nuevo ítem en la posición definida
  }

  if (puedeVerClima && moduloActivo("clima_organizacional")) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    addItemsUnique(menuItemClima, insertAt);
  }


  if (puedeVerEvaluacionVisitas && moduloActivo("evaluacion_visitas")) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    pages.splice(insertAt, 0, ...menuItemEvaluacionVisitas);
  }
  if (puedeVerRelevamientoVisitas) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    addItemsUnique(menuItemRelevamientoVisitas, insertAt);
  }
  // Visitas de Reconocimiento a nuevos PS: solo Operaciones
  // (fiscales, jefe de operaciones, gerente de operaciones). Desarrollador para soporte.
  const puedeVerReconocimiento = esDesarrollador || esFiscal || esJefeOperaciones
    || cargoNorm.includes('gerente de operaciones');
  if (puedeVerReconocimiento) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    addItemsUnique(menuItemReconocimiento, insertAt);
  }
  if (puedeVerVisitasUE && moduloActivo("visitas_unidades_especializadas")) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    addItemsUnique(menuItemVisitasUE, insertAt);
  }
  // Repro (Relevamiento Operativo) - fiscales. Oculto de momento (ya no se está usando).
  // if (esFiscal) {
  //   const idxRecibos = pages.findIndex(p => p.url === "/salarios");
  //   const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
  //   addItemsUnique(menuItemRelevamientoOperativo, insertAt);
  // }
  // Orden de Trabajo - fiscales
  if (esFiscal) {
    const idxRepro = pages.findIndex(p => p.url === "/relevamiento-operativo");
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRepro >= 0 ? idxRepro + 1 : idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    addItemsUnique(menuItemOrdenTrabajo, insertAt);
  }
  // Rutinas de limpieza (TD-11191) - fiscales, jefes de operaciones y desarrollo
  if (esFiscal || esJefeOperaciones || cargoNorm.includes('jefe de ope') || esDesarrollador) {
    const idxOT = pages.findIndex(p => p.url === "/orden-trabajo");
    const insertAt = idxOT >= 0 ? idxOT + 1 : pages.length;
    addItemsUnique(menuItemRutinas, insertAt);
  }
  // Reporte jerárquico: visible todo el año pero solo para el usuario autorizado
  if (puedeVerReporteEval && moduloActivo("reporte_eval_desempeno")) {
    const idxRecibos = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos >= 0 ? idxRecibos + 1 : pages.length;
    pages.splice(insertAt, 0, ...menuItemReporteEvaluacion);
  }

  if (puedeEvaluarCapacitaciones && moduloActivo("evaluacion_capacitacion")) {
    const idxRecibos2 = pages.findIndex(p => p.url === "/salarios");
    const insertCap = idxRecibos2 >= 0 ? idxRecibos2 + 2 : pages.length;
    pages.splice(insertCap, 0, ...menuItemEvaluacionCapacitacion);
  }
  if ((esCapacitadorTecnico || esCoordinadorCap || esJefeOperaciones) && moduloActivo("asignaciones_capacitador")) {
    const idxRecibos3 = pages.findIndex(p => p.url === "/salarios");
    const insertAsign = idxRecibos3 >= 0 ? idxRecibos3 + 1 : pages.length;
    pages.splice(insertAsign, 0, ...menuItemAsignacionesCapacitador);
  }

  // Admins de Seguridad (AE_C_Admin): registran aunque su cargo no sea de capacitador.
  const registraPorTabla = Boolean(rolCap?.tipos_admin.length);
  if ((puedeRegistrarCapacitacion && moduloActivo("registro_capacitacion")) || registraPorTabla) {
    const idxSalarios = pages.findIndex(p => p.url === "/salarios");
    const insertReg = idxSalarios >= 0 ? idxSalarios + 1 : pages.length;
    addItemsUnique(menuItemRegistroCapacitacion, insertReg);
  }

  // Capacitaciones asignadas (cierre de Solicitudes de Capacitación): el
  // capacitador técnico. Los solicitantes van por el hub Solicitudes.
  if (esCapacitadorTecnico && moduloActivo("solicitudes_capacitacion")) {
    const idxSal = pages.findIndex(p => p.url === "/salarios");
    addItemsUnique(menuItemSolicitudesCapacitacion, idxSal >= 0 ? idxSal + 1 : pages.length);
  }

  // Historial de capacitaciones: capacitador, coordinador y fiscal
  const cargoTxtUpper = (cargo || "").toUpperCase();
  const esFiscalCap = cargoTxtUpper.includes("FISCAL") || esGerenteOperaciones;
  const puedeVerHistorial = puedeRegistrarCapacitacion || esFiscalCap;
  if ((puedeVerHistorial && moduloActivo("historial_capacitacion")) || registraPorTabla) {
    const idxRefRegistro = pages.findIndex(p => p.url === "/registro-capacitacion");
    const insertHist = idxRefRegistro >= 0
      ? idxRefRegistro + 1
      : (() => {
          const idxSal = pages.findIndex(p => p.url === "/salarios");
          return idxSal >= 0 ? idxSal + 1 : pages.length;
        })();
    addItemsUnique(menuItemHistorialCapacitacion, insertHist);
  }

  if (puedeVerLimpiezas && moduloActivo("limpiezas_profundas")) {
    const idxPedido = pages.findIndex(p => p.url === "/pedido-de-productos");
    const insertAt = idxPedido >= 0 ? idxPedido + 1 : pages.length;
    pages.splice(insertAt, 0, ...menuItemLimpiezasProfundas);
  }
  // Permitir acceso explícito por cédula autorizada aunque el módulo esté restringido por cargo.
  if (esUsuarioServiciosEspecializados || (esDesarrollador && moduloActivo("servicios_especializados"))) {
    const idxRecibos3 = pages.findIndex(p => p.url === "/salarios");
    const insertAt = idxRecibos3 >= 0 ? idxRecibos3 + 1 : pages.length;
    pages.splice(insertAt, 0, ...menuItemServiciosEspecializados);
  }

  if (esOperario && moduloActivo("mis_asignaciones")) {
    const idxHistorial = pages.findIndex(p => p.url === "/historial-de-trabajo");
    const insertAt = idxHistorial >= 0 ? idxHistorial + 1 : pages.length;
    pages.splice(insertAt, 0, ...menuItemMisAsignaciones);
  }
  // Mi Rutina (TD-11191) - operarios
  if (esOperario) {
    const idxAsig = pages.findIndex(p => p.url === "/mis-asignaciones" || p.url === "/historial-de-trabajo");
    const insertAt = idxAsig >= 0 ? idxAsig + 1 : pages.length;
    addItemsUnique(menuItemMiRutina, insertAt);
  }

  // Módulo de Eventos: visibilidad por acceso real (admin y/o tomador), no por cargo.
  if (esAdminEventos) {
    addItemsUnique(menuItemEventosAdmin, pages.length);
  }
  if (tieneAsistenciaEventos) {
    addItemsUnique(menuItemEventosAsistencia, pages.length);
  }

  // Entregas Masivas: visibilidad por rol real (admin/entregador/elegible),
  // evaluada sobre TODOS los temas vigentes (puede haber varios a la vez).
  // - Mi QR y Registrar entrega solo aplican a temas de ENTREGA directa
  //   (los temas de consumo/instalacion no tienen entrega directa).
  // - Mi stock aplica a cualquier tema donde el usuario opere (incluye consumo:
  //   ahi se hacen las transferencias y el consumo/instalacion).
  const hayTemaEntregaElegible = emTemas.some(
    (t) => t.es_elegible && t.modo_salida !== "consumo"
  );
  const hayTemaEntregaOperador = emTemas.some(
    (t) => (t.es_entregador || t.es_admin) && t.modo_salida !== "consumo"
  );
  const hayTemaStock = emTemas.some((t) => t.es_entregador || t.es_admin);

  if (hayTemaEntregaElegible) {
    addItemsUnique(menuItemEmMiQR, pages.length);
  }
  if (hayTemaEntregaOperador) {
    addItemsUnique(menuItemEmRegistrar, pages.length);
  }
  if (hayTemaStock) {
    addItemsUnique(menuItemEmMiStock, pages.length);
  }
  if (emRol?.es_admin) {
    addItemsUnique(menuItemEmAdmin, pages.length);
  }

  // Capacitaciones Administrativas: el anfitrion por padron administrativo; la
  // vista del participante (escanear QR / historial) para todos los cargos
  // (el backend ya acepta a cualquier funcionario con sesion).
  if (esAnfitrionCapAdm) {
    addItemsUnique(menuItemCapAdmAnfitrion, pages.length);
  }
  addItemsUnique(menuItemCapAdmMis, pages.length);

  // Agendamientos (TD-11766): todos reservan (el backend filtra por publico);
  // la gestion solo para admins, gestores y responsables internos.
  addItemsUnique(menuItemAgenda, pages.length);
  if (gestionaAgenda) {
    addItemsUnique(menuItemAgendaGestion, pages.length);
  }

  // Mantenimiento de temas y evaluaciones de Capacitaciones, separado por tipo.
  if (rolCap?.tipos_admin.includes("TECNICA")) {
    addItemsUnique(menuItemMantenimientoCapTecnica, pages.length);
  }
  if (rolCap?.tipos_admin.includes("SEGURIDAD")) {
    addItemsUnique(menuItemMantenimientoCapSeguridad, pages.length);
  }

  // Control de EPP: por tablas de admins / responsables, no por cargo.
  if (esOperadorEpp(rolEpp)) {
    addItemsUnique(menuItemEpp, pages.length);
  }
  if (rolEpp?.tiene_entregas) {
    addItemsUnique(menuItemMisEpp, pages.length);
  }

  // Administracion de Recursos: por tabla de admins, no por cargo.
  if (esAdminRec) {
    addItemsUnique(menuItemRecursosAdmin, pages.length);
  }

  const pagesFiltradasPorModulo = pages.filter((page) => {
    const url = page.url || "";
    if (url === "/home") return moduloActivo("home");
    if (url === "/marcar") return moduloActivo("marcacion");
    if (url === "/historial-de-trabajo") return moduloActivo("historial");
    if (url === "/reclamos") return moduloActivo("reclamos");
    if (url === "/salarios") return moduloActivo("salarios");
    if (url === "/recursos") return moduloActivo("recursos");
    // Documentaciones se separo de Sobre Nosotros: mismo permiso
    if (["/nosotros", "/documentaciones"].includes(url)) return moduloActivo("nosotros");
    if (url === "/denuncias") return moduloActivo("denuncias");
    if (url === "/cierre-diario") return moduloActivo("cierre_diario");
    return true;
  });

    // Filtrado final: elimina módulos sin permiso (cuando el item declare `cargos`).
  const paginasVisibles = pagesFiltradasPorModulo.filter(paginaPermitida);

  const getGroupKey = (page: AppPage): "jornada" | MenuAccordionKey | "info" | "sesion" => {
    if (page.onClick && !page.url) return "sesion";
    const url = page.url ?? "";
    if (["/home", "/marcar", "/historial-de-trabajo", "/mis-asignaciones", "/mi-rutina", "/reclamos", "/salarios"].includes(url)) {
      return "jornada";
    }
    if (
      url.startsWith("/evaluacion") ||
      url === "/asignaciones-capacitador" ||
      url === "/registro-capacitacion" ||
      url === "/historial-capacitacion" ||
      url.startsWith("/capacitaciones/mantenimiento") ||
      url === "/solicitudes-capacitacion" ||
      url === "/clima-organizacional" ||
      url === "/relevamiento-visitas" ||
      url === "/visitas-unidades-especializadas" ||
      url.startsWith("/relevamiento-operativo")
    ) {
      return "evaluaciones";
    }
    // "/orden-trabajo" no se agrupa aquí: cae en "operativa" (return por defecto).
    if (["/nosotros", "/documentaciones", "/denuncias", "/atencion-cliente", "/recursos", "/recursos/admin", "/agenda"].includes(url)) {
      return "info";
    }
    return "operativa";
  };

  const renderPageIcon = (page: AppPage) => {
    if (page.url === "/clima-organizacional") {
      return (
        <IonIcon
          slot="start"
          icon={peopleCircleOutline}
          color="primary"
        />
      );
    }

    return (
      <IonIcon
        slot="start"
        icon={page.icon}
        src={page.src}
        color="primary"
      />
    );
  };

  const grupos = [
    { key: "operativa" as const, title: "Operativa", icon: pencil },
    { key: "evaluaciones" as const, title: "Evaluaciones", icon: documentTextOutline },
  ];

  const pagesByGroup = paginasVisibles.reduce(
    (acc, page) => {
      const key = getGroupKey(page);
      if (key === "sesion") acc.sesion.push(page);
      else acc[key].push(page);
      return acc;
    },
    {
      jornada: [] as AppPage[],
      operativa: [] as AppPage[],
      evaluaciones: [] as AppPage[],
      info: [] as AppPage[],
      sesion: [] as AppPage[],
    }
  );

  const TOP_JORNADA_URLS = new Set(["/home", "/marcar"]);
  const jornadaTop = pagesByGroup.jornada.filter((p) => TOP_JORNADA_URLS.has(p.url ?? ""));
  const jornadaResto = pagesByGroup.jornada.filter((p) => !TOP_JORNADA_URLS.has(p.url ?? ""));

  const handleCerrarSesion = () => {
    setPerfilOpen(false);
    cerrarSesion();
  };

  useEffect(() => {
    const hasOperativa = pagesByGroup.operativa.length > 0;
    const hasEvaluaciones = pagesByGroup.evaluaciones.length > 0;

    if (openGroup === "operativa" && !hasOperativa) {
      setOpenGroup(hasEvaluaciones ? "evaluaciones" : null);
      return;
    }
    if (openGroup === "evaluaciones" && !hasEvaluaciones) {
      setOpenGroup(hasOperativa ? "operativa" : null);
      return;
    }
  }, [pagesByGroup.operativa.length, pagesByGroup.evaluaciones.length]);



  return (
    <IonMenu
      contentId={contentId}
      type="overlay"
      onIonWillOpen={() => setOpenGroup(null)}
    >
      <IonContent>
        <IonImg
          className="menu-logo" // aplicar estilos del logo lateral
          title="frase-sin-logo" // mantener título accesible consistente
          src="assets/images/el-mejor-sin-frase.png" // mostrar siempre el logo de producción
          alt="logo-sin-frase" // texto alternativo accesible
        />

        <Typography className="pb-1" variant="h6" color="primary">
          {user}
        </Typography>



        <IonList id="links-list">
          {jornadaTop.map((page) => (
            <IonMenuToggle key={page.url ?? page.title} autoHide={false}>
              <IonItem
                className={`${esSeleccionada(page)} menu-section-item`}
                routerLink={page.url}
                routerDirection="none"
                lines="none"
                detail={false}
                onClick={
                  page.onClick
                    ? page.onClick
                    : () => history.push(page.url ?? "/")
                }
              >
                {renderPageIcon(page)}
                <IonLabel>{page.title}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}

          {grupos
            .filter((g) => pagesByGroup[g.key].length > 0) // ocultar acordeones sin módulos
            .map((grupo) => {
            const groupPages = pagesByGroup[grupo.key];
            const hasPages = groupPages.length > 0;
            const isOpen = openGroup === grupo.key;
            return (
              <div key={grupo.key}>
                <IonItem
                  button
                  lines="none"
                  detail={false}
                  className={`menu-section-header ${isOpen ? "is-open" : ""}`}
                  disabled={!hasPages}
                  onClick={() => (hasPages ? setOpenGroup(isOpen ? null : grupo.key) : undefined)}
                >
                  <IonIcon slot="start" icon={grupo.icon} color="primary" />
                  <IonLabel>{grupo.title}</IonLabel>
                  <IonIcon
                    slot="end"
                    icon={isOpen ? chevronDownOutline : chevronForwardOutline}
                    color="medium"
                  />
                </IonItem>

                {hasPages && isOpen && (
                  <div className="menu-section-body">
                    {groupPages.map((page) => (
                      <IonMenuToggle key={page.url ?? page.title} autoHide={false}>
                        <IonItem
                          className={`${esSeleccionada(page)} menu-section-item`}
                          routerLink={page.url}
                          routerDirection="none"
                          lines="none"
                          detail={false}
                          onClick={
                            page.onClick
                              ? page.onClick
                              : () => history.push(page.url ?? "/")
                          }
                        >
                          {renderPageIcon(page)}
                          <IonLabel>{page.title}</IonLabel>
                        </IonItem>
                      </IonMenuToggle>
                    ))}
                  </div>
                )}
              </div>
            );
          })}

          {jornadaResto.map((page) => (
            <IonMenuToggle key={page.url ?? page.title} autoHide={false}>
              <IonItem
                className={`${esSeleccionada(page)} menu-section-item`}
                routerLink={page.url}
                routerDirection="none"
                lines="none"
                detail={false}
                onClick={
                  page.onClick
                    ? page.onClick
                    : () => history.push(page.url ?? "/")
                }
              >
                {renderPageIcon(page)}
                <IonLabel>{page.title}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}

          {pagesByGroup.info.map((page) => (
            <IonMenuToggle key={page.url ?? page.title} autoHide={false}>
              <IonItem
                className={`${esSeleccionada(page)} menu-section-item`}
                routerLink={page.url}
                routerDirection="none"
                lines="none"
                detail={false}
                onClick={
                  page.onClick
                    ? page.onClick
                    : () => history.push(page.url ?? "/")
                }
              >
                {renderPageIcon(page)}
                <IonLabel>{page.title}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}

          {pagesByGroup.sesion.map((page) => (
            <IonMenuToggle key={page.title} autoHide={false}>
              <IonItem
                className={esSeleccionada(page)}
                routerLink={page.url}
                routerDirection="none"
                lines="none"
                detail={false}
                onClick={page.onClick ? page.onClick : () => history.push(page.url ?? "/")}
              >
                {renderPageIcon(page)}
                <IonLabel>{page.title}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}
        </IonList>
      </IonContent>
      <IonModal
        isOpen={perfilOpen}
        onDidDismiss={() => setPerfilOpen(false)}
        cssClass="perfil-sheet-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Mi Perfil</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setPerfilOpen(false)}>Cerrar</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <PerfilPanel cerrarSesion={handleCerrarSesion} />
        </IonContent>
      </IonModal>

      <IonFooter className="menu-footer ion-no-border">
        <IonItem
          button
          lines="none"
          detail={false}
          className="menu-footer-action"
          onClick={() => setPerfilOpen(true)}
        >
          <IonIcon slot="start" icon={personCircleOutline} color="primary" />
          <IonLabel>Mi Perfil</IonLabel>
        </IonItem>
        <div className="version">Versión {version}</div>
      </IonFooter>
    </IonMenu>
  );
};

export default withRouter(Menu);
